import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./reserLock.css";

const ReserLock = () => {
  // State to manage form inputs
  const [formData, setFormData] = useState({
    id: 0, // Default value for Id
    Key: "", // Key input
    Value: true, // Default value for Value (boolean)
    note: "", // Note input
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({
    Key: "",
    note: "",
  });
  const [setting, setSetting] = useState([]);
  const [isEditing, setIsEditing] = useState(false); // State to track if editing
  const [editId, setEditId] = useState(null); // State to store the ID of the item being edited

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "Value") {
      setFormData({
        ...formData,
        Value: checked,
      });
    } else {
      const inputValue = type === "checkbox" ? checked : value;
      setFormData({
        ...formData,
        [name]: inputValue,
      });
    }

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const toggleSwitch = () => {
    setFormData({
      ...formData,
      Value: !formData.Value,
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { Key: "", note: "" };

    if (!formData.Key.trim()) {
      newErrors.Key = "المفتاح مطلوب";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const payloadPost = {
        id: 0, // Changed from Id to id
        Key: formData.Key,
        Value: formData.Value,
        note: formData.note,
      };

      const payloadPut = {
        id: formData.id, // Changed from Id to id
        Key: formData.Key,
        Value: formData.Value,
        note: formData.note,
      };

      let response;
      if (isEditing && formData.id) {
        response = await axios.put(
          `https://api.generalhome.sa/api/Settings/PutSettings/${formData.id}`,
          payloadPut,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        response = await axios.post(
          "https://api.generalhome.sa/api/Settings/PostSetting",
          payloadPost,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      Swal.fire({
        icon: "success",
        title: "تم!",
        text: isEditing
          ? "تم تحديث البيانات بنجاح!"
          : "تم إرسال البيانات بنجاح!",
        confirmButtonText: "حسناً",
      });

      setFormData({
        id: 0,
        Key: "",
        Value: true,
        note: "",
      });
      setIsEditing(false);
      setEditId(null);
      getSetting();
    } catch (error) {
      console.error("Error submitting data:", error);
      Swal.fire({
        icon: "error",
        title: "خطأ!",
        text: "حدث خطأ أثناء إرسال البيانات!",
        confirmButtonText: "حسناً",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getSetting = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        "https://api.generalhome.sa/api/Settings/GetSettings"
      );

      // Map the API response to ensure consistent property names
      const settings = response.data.map((item) => ({
        ...item,
        id: item.Id || item.id, // Handle both Id and id from API
        status: item.Value ? "مفتوح" : "مغلق",
      }));

      setSetting(settings);
    } catch (err) {
      console.error("Error fetching settings:", err);
      setErrors({ ...errors, note: "حدث خطأ أثناء جلب البيانات!" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (id) => {
    const settingToEdit = setting.find(
      (item) => item.Id === id || item.id === id
    );
    if (settingToEdit) {
      setFormData({
        id: settingToEdit.Id || settingToEdit.id, // Handle both Id and id
        Key: settingToEdit.Key,
        Value: settingToEdit.Value,
        note: settingToEdit.note || "",
      });
      setIsEditing(true);
      setEditId(id);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من استعادة هذه البيانات!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "نعم، احذفها",
      cancelButtonText: "إلغاء",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(
          `https://api.generalhome.sa/api/Settings/DeleteSetting/${id}`
        );
        setSetting((prevSettings) =>
          prevSettings.filter(
            (setting) => setting.Id !== id && setting.id !== id
          )
        );
        Swal.fire({
          icon: "success",
          title: "تم!",
          text: "تم حذف البيانات بنجاح!",
          confirmButtonText: "حسناً",
        });
      } catch (error) {
        console.error("Error deleting setting:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ!",
          text: "حدث خطأ أثناء حذف البيانات!",
          confirmButtonText: "حسناً",
        });
      }
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  const keyTranslations = {
    cleanNotes: "تنظيف",
    maintainanceNotes: "صيانه",
    Main: "صفحة الحجز",
  };

  return (
    <>
      <section className="reserLock">
        <div className="reserLock-container container">
          <h2>تعديل الاعدادات</h2>
          <form onSubmit={handleSubmit}>
            {/* Key Input */}
            <div className="form-group">
              <label htmlFor="Key">المفتاح:</label>
              <input
                type="text"
                id="Key"
                name="Key"
                value={formData.Key}
                onChange={handleInputChange}
                placeholder="أدخل المفتاح"
                disabled={isEditing}
              />
              {errors.Key && (
                <span className="error-message">{errors.Key}</span>
              )}
            </div>

            {/* Value Input (Switch Button) */}
            <div className="form-group">
              <label>قفل شاشه الحجز:</label>
              <div
                className={`switch ${formData.Value ? "active" : ""}`}
                onClick={toggleSwitch}
              >
                <div className="slider"></div>
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="submit-button"
              disabled={isLoading}
            >
              {isLoading ? "جاري الحفظ..." : isEditing ? "تحديث" : "حفظ"}
            </button>
          </form>

          {/* Table to display settings */}
          <div className="table-responsive-sm overflow-auto">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">المفتاح</th>
                  <th scope="col">القيمة</th>
                  <th scope="col">الحالة</th>
                  <th scope="col" className="text-center">
                    التحكم
                  </th>
                </tr>
              </thead>
              <tbody>
                {setting.map((item, index) => (
                  <tr key={index}>
                    <td>{keyTranslations[item.Key] || item.Key}</td>
                    <td>{item.Value ? "مفعل" : "غير مفعل"}</td>
                    <td>{item.status}</td>
                    <td className="text-center d-flex justify-content-center buttons-box">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => handleEdit(item.Id)}
                      >
                        تعديل
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleDelete(item.Id)}
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReserLock;
